import React, { useEffect, useMemo, useState } from "react";
import Navbar from "../../../common/layout/Navbar";
import
{
  AttendanceTypes,
  LicenseTypes,
  PageFor
} from "../../../../utils/Enum.types";
import { Title } from "../../../../stories/Title/Title";
import { Button } from "../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import useAssetTableJson from "../../../../json/useAssetTableJson";
import { TableHeaderProps } from "../../../../utils/types";
import
{
  GridAlignment,
  GridColumnVisibilityModel,
  GridValidRowModel
} from "@mui/x-data-grid-pro";
import useUrlParams from "../../../../customHooks/useUrlParams";
import Input from "../../../../stories/Input/Input";
import { toInputStandardDate } from "../../../../utils/UtilFunctions";
import { Checkbox, TextField } from "@mui/material";
import { StyledDatagrid } from "../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../styles/Variables";
import { ColumnVisibilityFor } from "../../../../utils/Enum.Datagrid";
import { CustomDrawer } from "../../../../styles/CustomDrawerStyles";
import AttendedDetails from "./AttendedDetails";
import Close from "../../../../images/Close.svg";
import { useLazyQuery, } from "@apollo/client";
import { GetMomAttResult, GetMomAttVars } from "./queries/types";
import EmpTypeSelect, { empType } from "../../../../customComponents/EmpTypeSelect";
import { GetEmpAttendance } from "../users/queries/queries";
import { EmpMaster, EmpMasterEdge, EmpMasterOrderField, EmpQueryType, GetEmpResult, GetEmpVars } from "../users/queries/types";
import { OrderDirection } from "../../../../utils/commonQueryTypes";
import { FETCH_MORE_DATA, ROWS_PER_PAGE } from "../../../../utils/constants";
import { GetMomAtt } from "./queries/query";


interface Props
{
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  pageType: PageFor;
  date: string;
  latest: boolean;
}
const AttendanceList = ( { setModalFlag, pageType, date, latest }: Props ) =>
{
  const navigate = useNavigate();
  const { MinutesOfMeeting } = useAssetTableJson();
  const [ chooseSelected, setChooseSelected ] = useState( false );
  const [ attMarked, setAttMarked ] = useState( false );
  const [ hasNextPage, setHasNextPage ] = useState<boolean>( true );
  const [ endCursor, setEndCursor ] = useState<string | null>( null );
  const [ employeeType, setEmpType ] = useState<empType>( empType.NONE );
  const [ employees, setEmployees ] = useState<EmpMasterEdge[]>( [] );
  const [ presentEmps, setPresentEmps ] = useState<EmpMaster[]>( [] );
  const { customer_id, momID } = useUrlParams();

  const [ searchEmployee, setSearchEmployee ] = useState( "" );
  const [ GetAttendance, { data, loading, fetchMore } ] = useLazyQuery<
    GetEmpResult,
    GetEmpVars
  >( GetEmpAttendance );


  const [ GetAtt, { data: attData } ] = useLazyQuery<
    GetMomAttResult,
    GetMomAttVars
  >( GetMomAtt );

  const selectedIds = useMemo( () =>
  {
    return presentEmps.map( ( emp ) => emp.id );
  }, [ presentEmps ] )


  // const empTypes = [ empType.ACP,
  // empType.ASI,
  // empType.DCP,
  // empType.JCP,
  // empType.PC,
  // empType.PSI,
  // empType.WPC,
  // empType.WPSI,
  // empType.WASI,
  // empType.HELP_DESK,
  // empType.PMU, ]

  useEffect( () =>
  {
    if ( customer_id )
    {
      GetAttendance( {
        variables: {
          customer_id,
          after: null,
          first: ROWS_PER_PAGE,
          input: {
            queryType: EmpQueryType.BY_TYPE,
            empType: employeeType === empType.NONE ? [] : [ employeeType ],
            companyID: 0,
            ldgrID: 0,
            siteID: 0,
            subsidiaryID: 0,
          },
          orderBy: {
            direction: OrderDirection.ASC,
            field: EmpMasterOrderField.NAME,
          },
          name: searchEmployee,
        },
      } );
    }
  }, [
    customer_id,
    GetAttendance,
    employeeType,
    searchEmployee

  ] )

  useEffect( () =>
  {
    if ( customer_id && momID )
    {
      GetAtt( {
        variables: {
          customerID: customer_id,
          momID,
          projectID: 0,
          latest,

        },
      } ).then( ( { data } ) =>
      {
        if ( data && data.GetMomAtt )
        {
          setPresentEmps( data.GetMomAtt.map( ( { empDetails } ) => empDetails ) );
        }
      } );
    }
  }, [
    customer_id,
    momID,
    GetAtt,
    attData,
    latest

  ] )

  const dynamicHeaders: TableHeaderProps[] = MinutesOfMeeting.Attenadance.filter( ( header ) => header.field !== "status" && header.field !== "vendor_name" ).map(
    ( header ) => ( {
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      renderCell: ( params ) =>
      {
        if ( header.field === "id" )
        {
          return (
            <>
              <Checkbox
                checked={selectedIds.includes( params.row.empNode.id )}
                onChange={( e ) =>
                {
                  handleCheckboxChange( e, params.row.empNode );
                }}
              />
              {params.row.id}
            </>
          );
        } else if ( header.field === "status" )
        {
          return (
            <>
              <span
                className={
                  params.row.status === AttendanceTypes.Present
                    ? "font-green"
                    : "font-red"
                }
              >
                {" "}
                {params.row.status}
              </span>
            </>
          );
        } else return params.value;
      }
    } )
  );

  const columns = [ ...dynamicHeaders ];


  const handleCheckboxChange = ( e: React.ChangeEvent<HTMLInputElement>, node: EmpMaster ) =>
  {

    const checked = ( e.target as HTMLInputElement ).checked;


    if ( checked )
    {
      setPresentEmps( ( prev ) => [ ...prev, node ] );
    }
    else
      setPresentEmps( presentEmps.filter( ( { id } ) => id !== node.id ) )
        ;
  };

  const [ columnVisibilityModel, setColumnVisibilityModel ] =
    useState<GridColumnVisibilityModel>( {} );

  useEffect( () =>
  {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.MOM_ATTENDANCE_LIST
    );
    if ( savedModel )
    {
      setColumnVisibilityModel( JSON.parse( savedModel ) );
    }
  }, [] );

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) =>
  {
    setColumnVisibilityModel( newModel );
    localStorage.setItem(
      ColumnVisibilityFor.MOM_ATTENDANCE_LIST,
      JSON.stringify( newModel )
    );
  };


  // const handleAttendance = () => {
  //   AddAttendance({
  //     variables: {
  //       customerID: customer_id!,
  //       user_details,
  //       input: {
  //         momID: 1,
  //         attendees: selectedEmployee.join(",")
  //       }
  //     }
  //   })
  // }

  const handleScroll = () =>
  {
    if ( hasNextPage && !loading )
    {
      fetchMore( {
        variables: {
          first: FETCH_MORE_DATA,
          after: endCursor,
        },
        updateQuery: ( prevResult, { fetchMoreResult } ) =>
        {
          if ( !fetchMoreResult ) return prevResult;

          const newEdges = fetchMoreResult.GetEmp.edges;
          const pageInfo = fetchMoreResult.GetEmp.pageInfo;
          setEndCursor( pageInfo.endCursor );
          setHasNextPage( pageInfo.hasNextPage );

          const duplicateCheck = prevResult.GetEmp.edges.filter(
            ( { node: { id } } ) =>
              newEdges.findIndex(
                ( { node: { id: newId } } ) => newId === id
              ) !== -1
          );

          if ( duplicateCheck.length > 0 ) return prevResult;

          return {
            GetEmp: {
              edges: [ ...employees, ...newEdges ],
              pageInfo,
              totalCount: data ? data.GetEmp.totalCount! : 0,
            },
          };
        },
      } );
    }
  };


  const rows: GridValidRowModel[] = useMemo( () =>
  {
    return data ? data.GetEmp.edges.map( ( { node }, index ) => ( {
      id: index + 1,
      employee_name: node.name,
      user_type: node.empType,
      empNode: node,

    } ) ) : []
  }, [

    data
  ] )


  useEffect( () =>
  {
    if ( data && !loading )
    {
      const newData = data.GetEmp.edges;

      if ( endCursor )
      {
        const updatedNewData = newData.map( ( newEmp ) =>
        {
          const filteredStudent = employees.find(
            ( employee ) => employee.node.id === newEmp.node.id
          );
          if ( filteredStudent )
          {
            return {
              ...newEmp,
              node: {
                ...newEmp.node,
              },
            };
          }
          return newEmp;
        } );
        setEmployees( updatedNewData );

      } else
      {
        setEmployees( newData );

      }
      setEndCursor( data.GetEmp.pageInfo.endCursor );
    } // eslint-disable-next-line
  }, [ data, loading ] );





  return (
    <>
      {pageType === PageFor.MODAL ? (
        <>
          <div className="att-list__title">
            <Title>Attendance</Title>
            <img src={Close} alt="" onClick={() => setModalFlag( false )} />
          </div>
        </>
      ) : (
        <>
          <Navbar NavType={LicenseTypes.DASHBOARD} />
          <Title>Attendance</Title>
        </>
      )}

      <div className={`att-list${ pageType === PageFor.MODAL ? "__modal" : "" }`}>
        <div className="att-list__flex row g-0">
          <div className="col-2">
            <Input id="data_search" placeholder="Search..."
              onChange={( e ) => setSearchEmployee( e.target.value )}
            />
          </div>
          <div className="col-2">
            <EmpTypeSelect
              onChange={( newValue ) =>
              {
                if ( newValue )
                {
                  setEmpType( newValue as empType );
                } else
                {
                  setEmpType( empType.NONE )
                }
              }}

              value={employeeType}

              label="Employee Type"
              filterOptions={[ empType.VENDOR_MANAGER, empType.TECHNICIAN ]}


            />
          </div>
          <div className="col att-list__flex--title">
            {attData ?
              attData.GetMomAtt.length
                ? (
                  <span className="font-green">Attendance Marked</span>
                ) : (
                  <span className="font-red">Attendance not Marked</span>
                ) : null}
          </div>
          <div className="col-4 flex-end">
            <TextField
              label="Date"
              className="project-meetings__textfield"
              slotProps={{
                inputLabel: { shrink: true }
              }}
              disabled
              type="date"
              value={toInputStandardDate( date )}
            />
          </div>
        </div>
        <div className="att-list__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            disableRowSelectionOnClick
            hideFooter
            columnVisibilityModel={columnVisibilityModel}
            onRowsScrollEnd={() =>
            {
              handleScroll();
            }}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}
          />
        </div>
        {attMarked ? (
          <>
            <Button mode="edit" />
            <Button mode="delete" />{" "}
          </>
        ) : (
          <Button
            mode="choose"
            onClick={() => setChooseSelected( !chooseSelected )}
          />
        )}
        {pageType === PageFor.GENERAL ? (
          <Button mode="back" onClick={() => navigate( -1 )} />
        ) : (
          <Button mode="cancel" onClick={() => setModalFlag( false )} />
        )}
      </div>
      <CustomDrawer
        anchor="right"
        open={chooseSelected}
        onClose={() => setChooseSelected( !chooseSelected )}
      >
        <AttendedDetails setModalFlag={setChooseSelected}
          empDetails={presentEmps}
        />
      </CustomDrawer>
    </>
  );
};

export default AttendanceList;
